import React from 'react';
import {
  Dialog,
  DialogSurface,
  DialogBody,
  DialogTitle,
  DialogContent,
  Button,
} from '@fluentui/react-components';
import { DismissRegular, CheckmarkCircleRegular } from '@fluentui/react-icons';

interface SuccessDialogProps {
  isOpen: boolean;
  onClose: () => void;
  message?: string;
}

const SuccessDialog: React.FC<SuccessDialogProps> = ({
  isOpen,
  onClose,
  message = 'Operationen lyckades!',
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={(_, data) => !data.open && onClose()}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle
            action={
              <Button
                appearance="subtle"
                icon={<DismissRegular />}
                onClick={onClose}
              />
            }
          >
            Lyckades
          </DialogTitle>
          <DialogContent>
            <div className="flex items-center gap-3">
              <CheckmarkCircleRegular className="text-green-600 w-6 h-6" />
              <p className="text-sm">{message}</p>
            </div>
          </DialogContent>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};

export default SuccessDialog;
